var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1509 15C18.2575 15 20.7759 12.4816 20.7759 9.375C20.7759 6.2684 18.2575 3.75 15.1509 3.75C12.0443 3.75 9.52588 6.2684 9.52588 9.375C9.52588 12.4816 12.0443 15 15.1509 15Z",
    stroke: "currentColor",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4873 26.25C5.4873 21.8963 9.81859 18.375 15.1511 18.375C16.3211 18.375 17.4461 18.5437 18.4923 18.8587",
    stroke: "currentColor",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_16710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7759 19.5H25.2759M20.7759 21.2188H25.2759M23.9634 25.6875L20.7759 22.9375H21.9009C24.401 22.9375 24.401 19.5 21.9009 19.5",
    stroke: "currentColor",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_16710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.875,
    height: 7.875,
    fill: "white",
    transform: "translate(19.6509 18.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkAccount);
export default __webpack_public_path__ + "static/media/link_account.0f832377.svg";
export { ForwardRef as ReactComponent };